import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
  },
  // A Page aplica paddingTop 16px e paddingBottom 24px (assimétrico) e as
  // laterais vêm do Container (24px). Compensamos os 8px que faltam no topo para
  // o respiro externo do card ficar igual (24px) em cima, embaixo e nas
  // laterais. Só no app (no guest o layout é fullBleed, com lógica própria).
  appSpacing: {
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },
  // "Fura" o container centralizado (ex.: maxWidth do GuestsMainLayout) e ocupa
  // a largura total da viewport, mantendo um respiro lateral. Usar apenas em
  // layouts SEM menu lateral (guest); no app o conteúdo já preenche a área.
  fullBleed: {
    position: 'relative',
    left: '50%',
    right: '50%',
    width: '100vw',
    marginLeft: '-50vw',
    marginRight: '-50vw',
    // Recupera parte do padding vertical do layout/Page (topo ~56px, base ~56px)
    // para o chat usar mais altura, mantendo um respiro padronizado (ver root).
    marginTop: theme.spacing(-4),
    marginBottom: theme.spacing(-7),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  // Cabeçalho da tela: seta de voltar + título, no padrão do ContentHeader.
  // Altura fixa (48 do IconButton + 16 da margem = 64px) para que o desconto
  // aplicado ao grid abaixo seja exato e o respiro vertical não mude.
  screenHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    height: theme.spacing(6),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  screenTitle: {
    fontWeight: 600,
  },
  // Em md+ as colunas ficam lado a lado; usamos nowrap para que, ao surgir o
  // painel, a largura do chat (12→8) possa transicionar sem o painel "quebrar"
  // para a linha de baixo durante a animação. No mobile mantém o empilhamento.
  gridBase: {
    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap',
    },
  },
  // Desconto da altura da viewport para o card preencher exatamente a área de
  // conteúdo, deixando 24px de respiro em cima e embaixo (igual às laterais).
  // 88px = 64 (topbar) + 16 (paddingTop Page) + 8 (appSpacing); +64 do
  // cabeçalho (screenHeader) que agora fica acima do grid.
  gridApp: {
    height: 'calc(100vh - 152px - var(--dpoday-banner-height, 0px))',
    [theme.breakpoints.up('lg')]: {
      // Em lg+ o ContentMain.wrapper adiciona paddingBottom 12px, então 12px
      // a menos (100 + 64).
      height: 'calc(100vh - 164px - var(--dpoday-banner-height, 0px))',
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  // No guest (fullBleed) o chat ocupa quase toda a viewport (112 + 64).
  gridFullBleed: {
    height: 'calc(100vh - 176px)',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  column: {
    height: '100%',
    minWidth: 0,
    // Suaviza a redução de largura do chat (md 12→8) quando o painel surge,
    // em sincronia com a animação de entrada do painel (panelEnter, 400ms).
    transition: theme.transitions.create(['flex-basis', 'max-width'], {
      duration: 400,
      easing: theme.transitions.easing.easeOut,
    }),
    [theme.breakpoints.down('sm')]: {
      height: '70vh',
    },
  },
}))

export default useStyles
